var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-item-title thin-border-bottom fs14"},[_c('i',{staticClass:"dot",style:({'background':_vm.statusObj.color})}),_c('span',[_vm._v(_vm._s(_vm.statusObj.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }